import React, { useState } from 'react';
import SolarPage from './pages/solarpage';
import HeatPumpPage from './pages/heatpumppage';
import UpgradePage from './pages/UpgradePage';
import './app.css';

export default function App() {
  const [activeTool, setActiveTool] = useState('solar');

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>☀️ SmartEnergyGuide Calculator Suite</h1>
        <p>Independent Advice, No Sales Pressure</p>
        <div style={{ display: 'flex', gap: '10px', marginTop: '1rem', justifyContent: 'center' }}>
          <button onClick={() => setActiveTool('solar')} style={{ background: activeTool === 'solar' ? '#0066cc' : '#334155', color: 'white', border: 'none', borderRadius: '6px', padding: '10px 20px', cursor: 'pointer', fontWeight: activeTool === 'solar' ? 600 : 400 }}>☀️ Solar ROI</button>
          <button onClick={() => setActiveTool('heatpump')} style={{ background: activeTool === 'heatpump' ? '#0066cc' : '#334155', color: 'white', border: 'none', borderRadius: '6px', padding: '10px 20px', cursor: 'pointer', fontWeight: activeTool === 'heatpump' ? 600 : 400 }}>🌡️ Heat Pump</button>
          <button onClick={() => setActiveTool('upgrade')} style={{ background: activeTool === 'upgrade' ? '#0066cc' : '#334155', color: 'white', border: 'none', borderRadius: '6px', padding: '10px 20px', cursor: 'pointer', fontWeight: activeTool === 'upgrade' ? 600 : 400 }}>🏠 Whole Home</button>
        </div>
      </header>
      <main className="app-main">
        {activeTool === 'solar' && <SolarPage />}
        {activeTool === 'heatpump' && <HeatPumpPage />}
        {activeTool === 'upgrade' && <UpgradePage />}
      </main>
    </div>
  );
}